import { Component } from "@angular/core";

@Component({
  selector: "app-chat-button",
  templateUrl: "./chat-button.component.html",
  styleUrls: ["./chat-button.component.scss"],
})
export class ChatButtonComponent {
  openChat(): void {
    // TODO GLOR-110: Implement chat functionality
    alert("Chat feature coming soon!");
  }
}
